export default __webpack_public_path__ + "static/Digital-IDA-Unbranded-Patient-Tearsheet-21349c603e90475a815197f626ccab07.jpg";